import apiClient from '../config/axiosInterceptors';
import { ResponseHandler } from '../config/responseHandler';
import { API_ENDPOINTS } from '../constants/api';

class CardService {
  /**
   * Save a new card
   * @param {Object} cardPayload - Card payload containing card_token, card_brand, last4, exp_month, exp_year, is_default, first_name, last_name
   * @returns {Promise<Object>} Create card response
   */
  async saveCard(cardPayload) {
    try {
      const response = await apiClient.post(API_ENDPOINTS.CARD, cardPayload);
      return ResponseHandler.handleSuccess(response, 'Card saved successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to save card');
    }
  }

  /**
   * Fetch cards for the authenticated user
   * @returns {Promise<Object>} Cards response
   */
  async fetchCards() {
    try {
      const response = await apiClient.get(API_ENDPOINTS.CARD);
      return ResponseHandler.handleSuccess(response, 'Cards fetched successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to fetch cards');
    }
  }

  /**
   * Set a card as default
   * @param {string} cardId - Card identifier
   * @returns {Promise<Object>} Set default response
   */
  async setDefaultCard(cardId) {
    try {
      const response = await apiClient.put(`${API_ENDPOINTS.CARD}/${cardId}/default`, {
        _id: cardId,
        is_default: true,
      });
      return ResponseHandler.handleSuccess(response, 'Default card updated successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to update default card');
    }
  }

  /**
   * Delete a card for the authenticated user
   * @param {string} cardId - Card identifier
   * @returns {Promise<Object>} Delete response
   */
  async deleteCard(cardId) {
    try {
      const response = await apiClient.delete(`${API_ENDPOINTS.CARD}/${cardId}`);
      return ResponseHandler.handleSuccess(response, 'Card deleted successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to delete card');
    }
  }

  /**
   * Check if a card has active subscription
   * @param {string} cardId - Card identifier
   * @returns {Promise<Object>} Subscription status response
   */
  async checkActiveSubscription(cardId) {
    try {
      const response = await apiClient.get(`${API_ENDPOINTS.CARD}/${cardId}/activeSubscription`);
      return ResponseHandler.handleSuccess(response, 'Active subscription status fetched successfully');
    } catch (error) {
      throw ResponseHandler.handleError(error, 'Failed to check active subscription');
    }
  }
}

export default new CardService();

